export default __webpack_public_path__ + "442f6e897d9a6a19ce9d85387d496811.jpg";